// extracted by mini-css-extract-plugin
export var md = "_25-4";
export var semantic = "_25-5";
export var sm = "_25-3";
export var text = "_25-6";
export var toggleInput = "_25-0";
export var toggleSwitch = "_25-1";
export var xs = "_25-2";